import GoogleMaps from './google-maps'

export default GoogleMaps
export { default as SearchPlace } from './search-place'
